import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { apiClient } from '../../../api/client/axios';
import { showSnackbar } from '../../../store/snackbarSlice';

const fetchSubscription = async (query) => {
  const { data } = await apiClient.get(`/subscriptions/${query.queryKey[1]}`);
  return data;
};

export const useGetSubscriptionHandler = (id) => {
  const dispatch = useDispatch();
  const [subscription, setSubscription] = useState(undefined);

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['subscription', id],
    queryFn: fetchSubscription,
    enabled: Boolean(id),
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (data) setSubscription(data);
  }, [data]);

  useEffect(() => {
    if (!isError) return;
    if (error instanceof AxiosError) {
      dispatch(showSnackbar({ message: error.response?.data?.message || error.message, severity: 'error' }));
      return;
    }
    dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
  }, [dispatch, error, isError]);

  return { subscription, isLoading };
};
